<template>
  <div
      class="modal-overlay"
      @click.self="closeModal"
      role="dialog"
      aria-modal="true"
  >
    <div class="modal" ref="modal" tabindex="-1">
      <header class="modal-header">
        <slot name="header"></slot>
        <button class="close-button" @click="closeModal" aria-label="Close">&times;</button>
      </header>
      <section class="modal-body">
        <slot name="body"></slot>
      </section>
      <footer class="modal-footer">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalComponent',
  methods: {
    closeModal() {
      this.$emit('close');
    },
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
    this.$refs.modal.focus();
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal {
  background: white;
  color: var(--rich-black);
  padding: 24px;
  border-radius: 12px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  outline: none;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

@media (max-width: 600px) {
  .modal {
    width: 90%;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 12px;
  margin-bottom: 20px;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--hollywood-cerise);
  cursor: pointer;
  transition: color 0.3s ease;
}

.close-button:hover {
  color: var(--violet-lush);
}

.modal-body {
  padding: 10px 0;
  overflow-y: auto;
  min-height: 0;
}

.modal-footer {
  padding: 10px 0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
